// extracted by mini-css-extract-plugin
export default {"wrapper":"ManageRules_wrapper__aYMzA","content":"ManageRules_content__eHqn0"};